<template>
  <div
    v-if="canFilter"
    class="slide-out"
    :class="{'slide-out--visible': isVisible}"
  >
  <div class="slide-out__toggle-button touch" @click="isVisible = !isVisible"><fa :icon="['far', 'chevron-left']" /></div>
    <div class="property-filter">
      <div class="property-filter__heading">{{ language.code === 'en' ? 'Filter your results by making selections below' : 'ترشيح النتائج عبر الاختيارات أدناه' }}</div>
      <div class="property-filter__inputs">
        <input-radio-select 
          class="property-filter__input"
          :label="language.code === 'en' ? 'Home Type' : 'نوع المنزل'"
          :selections="typeSelections"
          v-model="inputType"
          is-vertical="true"
        />
        <input-radio-select 
          class="property-filter__input"
          :label="language.code === 'en' ? 'Bedrooms' : 'غُرْفة النَّوْم'"
          :selections="bedsSelections"
          v-model="inputBeds"
        />
        <input-dropdown 
          class="property-filter__input"
          :label="language.code === 'en' ? 'View' : 'مَنْظَر'"
          :selections="viewSelections"
          v-model="inputView"
          is-vertical="true"
        /> 
        <input-filter-reset 
          class="property-filter__input"
        />
        <!-- <input-radio-select 
          class="property-filter__input"
          label="Bathrooms"
          :selections="bathsSelections"
          v-model="inputBaths"
        /> -->
        <!-- <input-radio-select 
          class="property-filter__input"
          label="Cars"
          :selections="carsSelections"
          v-model="inputCars"
        /> -->
      </div>
    </div>
  </div>
</template>
<script>
import InputRadioSelect from './InputRadioSelect'
import InputDropdown from './InputDropdown'
import InputFilterReset from './InputFilterReset'
import { mapGetters } from 'vuex'

export default {
  components: { InputRadioSelect, InputDropdown, InputFilterReset },

  data () {
    return {
      isVisible: false,

      bathsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 },
      ],
      bedsSelections: [
        { label: { en: 'Any', ar: 'أَيّ' }, value: false },
        { label: { en: '1', ar: '1' }, value: 1 },
        { label: { en: '2', ar: '2' }, value: 2 },
        { label: { en: '3', ar: '3' }, value: 3 },
        { label: { en: '4+', ar: '4+' }, value: 4 }
      ],
      carsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 },
      ],
      viewSelections: [
        { label: { en: 'All', ar: 'جميع الإطلالات' }, value: false },
        { label: { en: 'Beach Front', ar: 'إطلالة الشاطئ' }, value: 'Beach Front' },
        // { label: { en: 'Boulevard', ar: 'Boulevard' }, value: 'Boulevard' },
        // { label: 'Dry View', value: 'Dry View' },
        // { label: 'Lake', value: 'Lake' },
        { label: { en: 'Marina', ar: 'إطلالة المرسى' }, value: 'Marina' },
        { label: { en: 'Mild View', ar: 'إطلالة جزئية' }, value: 'Mild View' },
        { label: { en: 'Park View', ar: 'إطلالة الحديقة' }, value: 'Park' },
        // { label: 'Pool', value: 'Pool' },
        { label: { en: 'Standard', ar: 'قياسي' }, value: 'Standard' },
        { label: { en: 'Urban', ar: 'حضري' }, value: 'Urban' },
      ]
    }
  },

  computed: {
    ...mapGetters([
      'language'
    ]),

    canFilter () {
      return [
        'living-entry',
        'living-option',
        'subsection',
        'property'
      ].includes(this.$route.name)
    },

    inputBaths: {
      get () {
        return this.$store.state.filter.inputBaths
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputBaths: value
        })
      }
    },

    inputBeds: {
      get () {
        return this.$store.state.filter.inputBeds
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputBeds: value
        })
      }
    },

    inputCars: {
      get () {
        return this.$store.state.filter.inputCars
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputCars: value
        })
      }
    },

    inputType: {
      get () {
        return this.$store.state.filter.inputType
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputType: value
        })
      }
    },

    inputView: {
      get () {
        return this.$store.state.filter.inputView
      },
      set (value) {
        this.$store.commit('filter/SET_FILTER_PARAMETERS', {
          inputView: value
        })
      }
    },

    typeSelections () {
      let selections = [{ 
        label: {
          en: 'All',
          ar: 'جَميع'
        }, 
        value: null 
      }]
      this.$store.getters['property/dwellingTypes'].forEach(propertyType => {
        // hide palaces
        if (propertyType === 'palace') return

        var propertyTypeAr = ''

        if (propertyType === 'apartment') {
          propertyTypeAr = 'الشقق'
        }
        if (propertyType === 'villa') {
          propertyTypeAr = 'الفلل'
        }
        if (propertyType === 'townhome') {
          propertyTypeAr = 'المنازل المدمجة'
        }
        if (propertyType === 'palace') {
          propertyTypeAr = 'القصور'
        }

        var propertyTypeObject = {
          en: propertyType,
          ar: propertyTypeAr
        }
        selections.push({ label: propertyTypeObject, value: propertyType })
      })
      return selections
    }
  },

  watch: {
    $route () {
      if (this.$route.name === 'living-entry') {
        this.isVisible = true
      }
      if (this.$route.name === 'property') {
        this.isVisible = false
      }
    }
  }
}
</script>
<style lang="scss">
.slide-out {
  background: rgba(#000, 0.8);
  border-radius: 0.5rem 0 0 0.5rem;
  bottom: 20rem;
  padding: 3rem;
  position: absolute;
  right: 32rem;
  transform: translateX(calc(100%));
  transition: transform 0.6s ease-in-out;
  width: 25rem;
  z-index: 99;

  &--slider-present {
    bottom: 23.2rem;
  }

  &--visible {
    transform: none;

    svg {
      transform: scaleX(-1);
    }
  }

  svg {
    transition: transform 0.6s ease-in-out;
  }
  
  &__toggle-button {
    align-items: center;
    background: rgba(#000, 0.8);
    border-radius: 0.5rem 0 0 0.5rem;
    bottom: 4rem;
    display: flex;
    font-size: 2rem;
    height: 4rem;
    padding-left: 1.3rem;
    position: absolute;
    right: 100%;
    width: 4rem;
  }
}

.property-filter {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__heading {
    font-size: 1.6rem;
    line-height: 1;
    margin-bottom: 1em;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;
  }

  &__input {
    margin-bottom: 1rem;
  }
}
</style>